import { Outlet } from '@suntex.core/nav'

import Nav from '../components/Nav/Nav'

/**
 * returns JSX for layout
 */
function Layout() {
  return (
    <>
      {/* A "layout route" is a good place to put markup you want to
        share across all the pages on your site, like navigation. */}
      <div className="pageWrapper">
        <Nav />
        <div className="PageBodyWrapper">
          <Outlet />
        </div>
      </div>
      {/* An <Outlet> renders whatever child route is currently active,
      so you can think about this <Outlet> as a placeholder for the child routes we defined above. */}
    </>
  )
}

export default Layout
